export const INCREASE_QTY = "IncreaseQty";
export const DECREASE_QTY = "DecreaseQty";

export const GENERIC_EXPORT_LOAD = 'GENERIC_EXPORT_LOAD';
export const GENERIC_EXPORT_LOAD_ERROR = 'GENERIC_EXPORT_LOAD_ERROR';
export const GENERIC_EXPORT_RECEIVE = 'GENERIC_EXPORT_RECEIVE';
export const GENERIC_EXPORT_STORE_TYPE = 'GENERIC_EXPORT_STORE_TYPE';
export const GENERIC_EXPORT_STORE_TYPE_INDEX = 'GENERIC_EXPORT_STORE_TYPE_INDEX';
export const GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS = 'GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS';
export const GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES = 'GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES';
export const GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA = 'GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA';
